export default __webpack_public_path__ + "static/media/projectCardCategoryImg.06e22331.svg";